import { FC } from 'react';
import { Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useReuseDataLink } from './useReuseDataLink';

const ReuseDataLink: FC = () => {
  const { isVisible, reuseUrl } = useReuseDataLink();

  if (!isVisible) return null;

  return (
    <Link component={RouterLink} to={reuseUrl} underline="hover" sx={{ flexShrink: 0 }}>
      Reuse data from previous project
    </Link>
  );
};

export default ReuseDataLink;
